export default __webpack_public_path__ + "cec987739c55199c141bde51ab5ebde8.png";